import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import axios from 'axios'
import { socket } from './socket.js'
import { Calendar } from 'react-multi-date-picker'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import CustomSelect from '../components/atoms/Inputs/CustomSelect'
import CustomMultiSelect from '../components/atoms/Inputs/CustomMultiSelect'
import RadioBox from '../components/atoms/RadioBox'

import MenuItem from '@mui/material/MenuItem'
import CustomInput from '../components/atoms/Inputs/CustomInput'
import CustomMaskInput from '../components/atoms/Inputs/CustomMaskInput'
import CustomMaskInputWithHidden from '../components/atoms/Inputs/CustomMaskInputWithHidden'
import GooglePlaceAutoComplete from '../components/atoms/Inputs/GooglePlaceAutoComplete'
import CustomPhone from '../components/atoms/Inputs/CustomPhone.js'
import Webcam from './webcam'
import PasswordStrength from './passwordStrength'
import './productCommon.css'

import CheckBox from '../components/atoms/CheckBox'
import CustomTextArea from '../components/atoms/Inputs/CustomTextArea'
import Uploader from '../../product/common/uploader'

import FormHelperText from '@mui/material/FormHelperText'
import CustomAutocomplete from '../components/atoms/Inputs/CustomAutocomplete.js'
import { Button, Checkbox, ListSubheader, Tooltip } from '@mui/material'
import EmailEditor from '../components/atoms/EmailEditor'
import { ListItemText } from '@mui/material'
import { getCookie } from './api'

import './ckeditor.css'
import MultipleArray from '../components/molecules/MultipleArrayPopup'
import OtpInput from 'react-otp-input'
import GoogleCaptch from '../components/atoms/GoogleRecaptcha/index.js'
import CkeditorNew from './ckeditor.js'
import uploader from './ckeditor-uploader'
import { TwitterPicker } from 'react-color'
import { Editor as TINYMCE } from '@tinymce/tinymce-react'
import tinyMCEImageUpload from './tinymce-uploader'

import { DatePicker } from '@mui/x-date-pickers'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import SearchSelectComponent from '../components/atoms/Inputs/SearchSelectComponent.js'
import { format, isDate, parse, parseISO } from 'date-fns'
import CustomTagsInput from '../components/atoms/Inputs/CustomTagsInput.js'
import {
    sanitizeInputPayload,
    sanitizeTextInput,
    getSafeRedirectUrl,
} from './urlValidation'

let serverTime = new Date()
const monthFormat = 'YYYY-MM'
const yearFormat = 'YYYY'
let dateFormat = 'MM-DD-YYYY'
let dateTimeFormat = 'MM-DD-YYYY h:mm a'
const dateTimeSecondFormat = 'MM-DD-YYYY h:mm:ss a'
const timeFormat = 'h:mm a'

if (socket) {
    socket.on('sliservertime', (data) => {
        if (moment(data.dTime).isValid()) {
            serverTime = new Date(data.dTime)
        }
    })
}

const isEncodedURIComponent = (str) => {
    try {
        const decoded = decodeURIComponent(str)
        return decoded !== str
    } catch (error) {
        return false
    }
}

const errorCheck = (data, formik) => {
    return data.filter &&
        formik &&
        formik.touched &&
        formik.touched.filters &&
        formik.touched.filters[data.name] &&
        formik.errors &&
        formik.errors.filters &&
        formik.errors.filters[data.name]
        ? formik.errors.filters[data.name]
        : formik.touched[data.name] && formik.errors[data.name]
}

export const noImageAvailable = (e) => {
    e.target.src = '/assets/images/no_image.jpg'
    e.target.onError = null
    e.target.className += ' imgNotFound'
}

const multiSelectValue = (data, formik) => {
    return data.filter
        ? formik.values.filters[data.name].value.length <= data.options.length
            ? data.options
                  .filter((d) =>
                      formik.values.filters[data.name].value.length
                          ? !formik.values.filters[data.name].value.includes(
                                d.value
                            )
                          : true
                  )
                  .map((d) => d.value)
                  ?.flat()
            : (formik.values.filters[data.name].value.length = 0 && null)
        : formik.values[data.name].length <= data.options.length
        ? data.options
              .filter((d) =>
                  formik.values[data.name].length
                      ? !formik.values[data.name].includes(d.value)
                      : true
              )
              .map((d) => d.value)
              ?.flat()
        : (formik.values[data.name].length = 0 && null)
}

const helperText = (data, formik) => {
    return data.filter &&
        formik &&
        formik.touched &&
        formik.touched.filters &&
        formik.touched.filters[data.name] &&
        formik.errors &&
        formik.errors.filters &&
        formik.errors.filters[data.name]
        ? formik.errors.filters[data.name]
        : formik.touched[data.name] && formik.errors[data.name]
}

export const sortCategoryAlphabeticalCustom = (a, b, field) => {
    var nameA = a[field].toUpperCase() // ignore upper and lowercase
    var nameB = b[field].toUpperCase() // ignore upper and lowercase
    if (nameA < nameB) {
        return -1
    }
    if (nameA > nameB) {
        return 1
    }

    // names must be equal
    return 0
}

export const sortCategoryAlphabetical = (a, b) => {
    var nameA = a.description.toUpperCase() // ignore upper and lowercase
    var nameB = b.description.toUpperCase() // ignore upper and lowercase
    if (nameA < nameB) {
        return -1
    }
    if (nameA > nameB) {
        return 1
    }

    // names must be equal
    return 0
}
export const calculateAge = (birthday) => {
    let compareDate = moment(
        moment(birthday, dateFormat).format(dateFormat),
        dateFormat
    ).toDate()
    let ageDifMs = Date.now() - compareDate.getTime()
    let ageDate = new Date(ageDifMs) // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970)
}

export const calculatePercentage = (amount, percent) => {
    let percentAmount = 0
    let totalAmount = 0

    percentAmount = parseFloat(
        parseFloat(amount) * parseFloat(percent / 100)
    ).toFixed(2)
    totalAmount = parseFloat(
        parseFloat(amount) + parseFloat(percentAmount)
    ).toFixed(2)

    return { percentAmount, totalAmount }
}

export const converDateTime = (data) => {
    let dataReturn = null
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(dateTimeFormat)}`
        }
    }
    return dataReturn
}

export const converDate = (data, fieldData) => {
    let dataReturn = ''
    if (data) {
        if (moment(data).isValid()) {
            if (fieldData && fieldData?.customDateFormat) {
                dataReturn = `${moment(data).format(
                    fieldData?.customDateFormat
                )}`
            } else {
                dataReturn = `${moment(data).format(dateFormat)}`
            }
        }
    }
    return dataReturn
}

export const converTime = (data) => {
    let dataReturn = ''
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(timeFormat)}`
        }
    }
    return dataReturn
}

function shouldDisableDate(date, data) {
    if (data.shouldDisableDate && data.shouldDisableDate.length) {
        let allDates = data.shouldDisableDate
        if (allDates.find((e) => e == date.format('YYYY-MM-DD'))) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

// accepts array dates for data.shouldEnableDate in format 'YYYY-MM-DD'
function shouldEnableDate(date, data) {
    let allDates = data.shouldEnableDate
    if (allDates?.length > 0) {
        return allDates.find((e) => e == date.format('YYYY-MM-DD')) == undefined
    } else {
        return true
    }
}

export const urlFormat = (data) => {
    return data
        ? data.toLowerCase().replaceAll(' ', '_').replaceAll('/', '-')
        : ''
}

export const converYear = (data) => {
    let dataReturn = ''
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(yearFormat)}`
        }
    }
    return dataReturn
}

export const asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index += 1) {
        await callback(array[index], index, array)
    }
}

export const insertArrayIndex = (array, index, newItem) => {
    return array.splice(index, 0, ...newItem)
}

export const getCountryCode = (allCountries, countryName) => {
    let dataReturn = allCountries.filter((inner) => inner.name === countryName)
    if (dataReturn.length) {
        dataReturn = dataReturn[0]
    } else {
        dataReturn = ''
    }

    return dataReturn
}

export const getStateCode = (allStates, stateName) => {
    let dataReturn = allStates.filter((inner) => inner.name === stateName)
    if (dataReturn.length) {
        dataReturn = dataReturn[0]
    } else {
        dataReturn = ''
    }

    return dataReturn
}

export const formatDateWithFns = (
    inputDate,
    inputDateFormat = 'yyyy-MM-dd'
) => {
    let parsedDate = ''
    if (isDate(inputDate)) {
        parsedDate = inputDate
    } else if (typeof inputDate === 'string') {
        if (inputDate?.includes('T')) {
            parsedDate = parseISO(inputDate)
        } else if (inputDate?.includes('-')) {
            parsedDate = parse(inputDate, 'yyyy-MM-dd', new Date())
        }
    } else {
        parsedDate = inputDate
    }
    const formattedDate = format(parsedDate, inputDateFormat)

    return formattedDate
}

export const mapData = (page, multiform, step) => {
    const TINYMCE_PREMIUM_DISABLED =
        global.tinymcePremiumPluginsDisabled === true
    let formik = page.formik ? page.formik : page[0]?.formik
    let pageData
    dateFormat = global.dateFormat ? global.dateFormat : 'MM-DD-YYYY'
    dateTimeFormat = global?.defaultDateTimeFormat
        ? global.defaultDateTimeFormat
        : 'MM-DD-YYYY h:mm a'

    if (multiform) {
        pageData = page.data[step]
    } else {
        pageData = page.data ? page.data : page
    }
    let data =
        pageData && pageData.length
            ? pageData.map((data, index) => (
                  <>
                      <div key={index} className={data.class}>
                          {data.type === 'select' ? (
                              <>
                                  <CustomSelect
                                      label={data.label}
                                      inlineLabel={data.inlineLabel || true}
                                      id={data.id}
                                      value={
                                          data.value
                                              ? data.value
                                              : data.filter || data.table_search
                                              ? formik?.values?.filters?.[
                                                    data.name
                                                ]?.value
                                                  ? formik.values.filters[
                                                        data.name
                                                    ].value
                                                  : ''
                                              : formik.values[data.name]
                                      }
                                      autoFocus={data.autoFocus}
                                      className={data.className}
                                      variant={data.variant}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      size={data.size}
                                      onChange={
                                          data.onChange
                                              ? data.onChange
                                              : formik.handleChange
                                      }
                                      placeholder={data.placeholder}
                                      disabled={data.disabled}
                                      onBlur={formik.handleBlur}
                                      type={data.type}
                                      error={errorCheck(data, formik)}
                                      helperText={helperText(data, formik)}
                                      upperLabel={data.upperLabel}
                                      native={data.native}
                                      options={data.options}
                                      groupoptions={data.groupoptions}
                                  >
                                      {data.native ? (
                                          <>
                                              {!data.isNoDefaultOptionValue && (
                                                  <option
                                                      value=""
                                                      name={data.placeholder}
                                                  >
                                                      {data.placeholder}
                                                  </option>
                                              )}
                                              {data.options &&
                                                  data.options.map(
                                                      (opt, optindex) => (
                                                          <option
                                                              key={optindex}
                                                              value={opt.value}
                                                              name={opt.value}
                                                          >
                                                              {opt.show}
                                                          </option>
                                                      )
                                                  )}

                                              {data.groupoptions &&
                                                  data.groupoptions.map(
                                                      (opt, optindex) => (
                                                          <>
                                                              <optgroup
                                                                  label={
                                                                      opt.head
                                                                  }
                                                              >
                                                                  <>
                                                                      {opt.options.map(
                                                                          (
                                                                              opt,
                                                                              optindex
                                                                          ) => (
                                                                              <option
                                                                                  key={
                                                                                      optindex
                                                                                  }
                                                                                  value={
                                                                                      opt.value
                                                                                  }
                                                                                  name={
                                                                                      opt.value
                                                                                  }
                                                                              >
                                                                                  {
                                                                                      opt.show
                                                                                  }
                                                                              </option>
                                                                          )
                                                                      )}
                                                                  </>
                                                              </optgroup>
                                                          </>
                                                      )
                                                  )}
                                          </>
                                      ) : (
                                          <></>
                                      )}
                                  </CustomSelect>
                              </>
                          ) : data.type === 'autocomplete' ? (
                              <>
                                  <CustomAutocomplete
                                      label={data.label}
                                      id={data.id}
                                      multiple={data.multiple}
                                      isString={data.isString}
                                      onClear={data.onClear}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                              : formik.values[data.name]
                                      }
                                      autoFocus={data.autoFocus}
                                      triggerPasteEvent={data.triggerPasteEvent}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      size={data.size}
                                      onChange={(val) => {
                                          data.filter
                                              ? formik.setFieldValue(
                                                    `filters.${data.name}.value`,
                                                    val
                                                )
                                              : formik.setFieldValue(
                                                    data.name,
                                                    val
                                                )
                                      }}
                                      placeholder={data.placeholder}
                                      disabled={data.disabled}
                                      onBlur={formik.handleBlur}
                                      options={data.options}
                                      type={data.type}
                                      error={errorCheck(data, formik)}
                                      helperText={helperText(data, formik)}
                                      isTag={true}
                                  />
                              </>
                          ) : data.type === 'tagsInput' ? (
                              <>
                                  <CustomTagsInput
                                      label={data.label}
                                      id={data.id}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                              : formik.values[data.name]
                                      }
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      onChange={(val) => {
                                          data.filter
                                              ? formik.setFieldValue(
                                                    `filters.${data.name}.value`,
                                                    val
                                                )
                                              : formik.setFieldValue(
                                                    data.name,
                                                    val
                                                )
                                      }}
                                      placeholder={data.placeholder}
                                  />
                              </>
                          ) : data.type === 'searchdrop' ? (
                              <>
                                  <SearchSelectComponent
                                      label={data.label}
                                      id={data.id}
                                      multiple={data.multiple}
                                      onClear={data.onClear}
                                      forcePopupIcon={data.forcePopupIcon}
                                      phoneSearch={data?.phoneSearch}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                              : formik.values[data.name]
                                      }
                                      autoFocus={data.autoFocus}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      size={data.size}
                                      onChange={(val) => {
                                          data.filter
                                              ? formik.setFieldValue(
                                                    `filters.${data.name}.value`,
                                                    val
                                                )
                                              : formik.setFieldValue(
                                                    data.name,
                                                    val
                                                )
                                      }}
                                      placeholder={data.placeholder}
                                      disabled={data.disabled}
                                      style={data.style}
                                      onBlur={formik.handleBlur}
                                      options={data.options}
                                      getAllOptions={data.getAllOptions}
                                      type={data.type}
                                      error={errorCheck(data, formik)}
                                      helperText={helperText(data, formik)}
                                      focused={data?.focused}
                                      onClearDefault={data?.onClearDefault}
                                  />
                              </>
                          ) : data.type === 'misc' ? (
                              <>{data.content}</>
                          ) : data.type === 'switch' ? (
                              <>
                                  <FormGroup row className="customToggle">
                                      <FormControlLabel
                                          label={data.label}
                                          control={
                                              <Switch
                                                  checked={
                                                      formik.values[data.name]
                                                  }
                                                  onChange={(val) => {
                                                      if (data.filter) {
                                                          formik.setFieldValue(
                                                              `filters.${data.name}.value`,
                                                              val.target.checked
                                                                  ? 1
                                                                  : 0
                                                          )
                                                      } else {
                                                          formik.setFieldValue(
                                                              data.name,
                                                              val.target.checked
                                                          )
                                                      }
                                                  }}
                                                  name={data.name}
                                                  color={data.color}
                                              />
                                          }
                                      />
                                  </FormGroup>

                                  {formik.errors[data.name] &&
                                      formik.touched[data.name] && (
                                          <div className="checkboxError mb-4">
                                              <FormHelperText>
                                                  {formik.errors[data.name]}
                                              </FormHelperText>
                                          </div>
                                      )}
                              </>
                          ) : data.type === 'check' ? (
                              <>
                                  {data.options &&
                                      data.options.map((opt, optindex) => (
                                          <CheckBox
                                              key={optindex}
                                              name={
                                                  data.filter
                                                      ? `filters.${data.name}.value`
                                                      : data.name
                                              }
                                              disabled={data.disabled}
                                              label={opt.description}
                                              customized={opt.customized}
                                              checked={
                                                  data.filter
                                                      ? formik?.values?.filters[
                                                            data.name
                                                        ].value
                                                            ?.flat()
                                                            .indexOf(
                                                                opt.id.toString()
                                                            ) > -1
                                                      : formik?.values[
                                                            data.name
                                                        ]
                                                            ?.flat()
                                                            .indexOf(
                                                                opt.id.toString()
                                                            ) > -1
                                              }
                                              value={opt.id.toString()}
                                              onChange={
                                                  data.onChange
                                                      ? data.onChange
                                                      : formik.handleChange
                                              }
                                          />
                                      ))}
                                  <div className="checkboxError">
                                      <FormHelperText>
                                          {formik.errors[data.name] &&
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]}
                                      </FormHelperText>
                                  </div>
                              </>
                          ) : data.type === 'uploadDropZone' ? (
                              <>
                                  <Uploader
                                      formik={formik}
                                      name={data.name}
                                      icon={data.icon}
                                      titleText={data.titleText}
                                      innerText={data.innerText}
                                      folder={data.folder}
                                      maxLength={data.maxLength}
                                      multiple={data.multiple}
                                      multiplefilename={data.multiplefilename}
                                      reorder={data.reorder}
                                      accept={data.accept}
                                      objectImage={data.object_image}
                                      disableDeleting={data.disableDeleting}
                                      disableRotate={data.disableRotate}
                                      hideUploader={data.hideUploader}
                                      isCompress={
                                          data.isCompress
                                              ? data.isCompress
                                              : data.is_compress
                                              ? true
                                              : false
                                      }
                                      quality={
                                          data.quality || data.compress_quality
                                      }
                                      resultWidth={
                                          data.resultWidth ||
                                          data.compress_width
                                      }
                                      resultHeight={
                                          data.resultHeight ||
                                          data.compress_height
                                      }
                                      custom={data.custom}
                                      webcam={data.webcam}
                                      capture={data.capture}
                                      videoConstraints={data.videoConstraints}
                                      disableEditing={data.disableEditing}
                                      getBlobUrl={data.getBlobUrl}
                                      showFileName={data.showFileName}
                                      disabled={data?.disabled}
                                  ></Uploader>
                              </>
                          ) : data.type === 'phone' ? (
                              <>
                                  <CustomPhone
                                      id={data.id}
                                      value={formik.values[data.name]}
                                      autoFocus={data.autoFocus}
                                      name={data.name}
                                      disabled={data.disabled}
                                      shrink={formik.values[data.name] && true}
                                      onBlur={formik.handleBlur}
                                      onChange={(phone) =>
                                          formik.setFieldValue(data.name, phone)
                                      }
                                      label={data.label}
                                      placeholder={data.placeholder}
                                      type={data.type}
                                      error={errorCheck(data, formik)}
                                      onError={data.onError}
                                      minChar={data.minChar}
                                      maxChar={data.maxChar}
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      countryCodeEditable={
                                          data.countryCodeEditable
                                      }
                                      upperLabel={data.upperLabel}
                                      variant={data.variant}
                                      masks={data.masks}
                                  />
                              </>
                          ) : data.type === 'multiselect' ? (
                              <>
                                  <CustomMultiSelect
                                      label={data.label}
                                      id={data.id}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value || []
                                              : formik.values[data.name] || []
                                      }
                                      autoFocus={data.autoFocus}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      onChange={(event, value) => {
                                          let arrayValue =
                                              event.target.value?.flat()
                                          let allLength = data.filter
                                              ? formik.values.filters[data.name]
                                                    .value.length ===
                                                data.options.length
                                              : formik.values[data.name]
                                                    .length ===
                                                data.options.length
                                          if (
                                              allLength &&
                                              arrayValue.length ===
                                                  data.options.length
                                          ) {
                                              arrayValue = []
                                          }
                                          data.filter
                                              ? formik.setFieldValue(
                                                    `filters.${data.name}.value`,
                                                    arrayValue
                                                )
                                              : formik.setFieldValue(
                                                    data.name,
                                                    arrayValue
                                                )
                                      }}
                                      placeholder={data.placeholder}
                                      onBlur={formik.handleBlur}
                                      disabled={data.disabled}
                                      type={data.type}
                                      error={errorCheck(data, formik)}
                                      helperText={helperText(data, formik)}
                                      options={data.options}
                                      size={data.size}
                                  >
                                      <MenuItem
                                          value={multiSelectValue(data, formik)}
                                      >
                                          <Checkbox
                                              checked={
                                                  data.filter
                                                      ? formik.values.filters[
                                                            data.name
                                                        ].value?.flat()
                                                            .length ==
                                                        data.options.length
                                                          ? true
                                                          : false
                                                      : formik.values[
                                                            data.name
                                                        ]?.flat().length ==
                                                        data.options.length
                                                      ? true
                                                      : false
                                              }
                                              onChange={(val) => {
                                                  val.target.checked
                                                      ? data.filter
                                                          ? formik.setFieldValue(
                                                                `filters.${data.name}.value`,
                                                                formik.values.filters[
                                                                    data.name
                                                                ].value.concat(
                                                                    multiSelectValue(
                                                                        data,
                                                                        formik
                                                                    )
                                                                )
                                                            )
                                                          : formik.setFieldValue(
                                                                data.name,
                                                                formik.values[
                                                                    data.name
                                                                ].concat(
                                                                    multiSelectValue(
                                                                        data,
                                                                        formik
                                                                    )
                                                                )
                                                            )
                                                      : data.filter
                                                      ? formik.setFieldValue(
                                                            `filters.${data.name}.value`,
                                                            []
                                                        )
                                                      : formik.setFieldValue(
                                                            data.name,
                                                            []
                                                        )
                                              }}
                                          />
                                          <ListItemText primary={'All'} />
                                      </MenuItem>
                                      {data.options.map((opt, optindex) => (
                                          <MenuItem
                                              key={optindex}
                                              value={opt.value}
                                          >
                                              <Checkbox
                                                  checked={
                                                      data.filter
                                                          ? formik?.values?.filters[
                                                                data.name
                                                            ].value
                                                                ?.flat()
                                                                .indexOf(
                                                                    opt.value
                                                                ) > -1
                                                          : formik?.values[
                                                                data.name
                                                            ]
                                                                ?.flat()
                                                                .indexOf(
                                                                    opt.value
                                                                ) > -1
                                                  }
                                                  onChange={
                                                      data.onChange
                                                          ? data.onChange
                                                          : formik.handleChange
                                                  }
                                              />
                                              {opt.show}
                                          </MenuItem>
                                      ))}
                                  </CustomMultiSelect>
                              </>
                          ) : data.type === 'ckeditor5' ||
                            data.type === 'ckeditor' ||
                            (data.type === 'ckeditor4' &&
                                global?.nockeditor4) ? (
                              <>
                                  {data?.label ? (
                                      <label className="datePickerLabel text-left w-100">
                                          {data.label}
                                      </label>
                                  ) : null}

                                  <CkeditorNew
                                      formik={formik}
                                      data={data}
                                      dynamic_ckeditor_size={
                                          global?.dynamic_ckeditor_size
                                      }
                                  />

                                  <div className="checkboxError">
                                      <FormHelperText>
                                          {formik.errors[data.name] &&
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]}
                                      </FormHelperText>
                                  </div>
                              </>
                          ) : data.type === 'ckeditor4' ? (
                              <>
                                  {(() => {
                                      try {
                                          const {
                                              CKEditor,
                                          } = require('ckeditor4-react')
                                          return (
                                              <>
                                                  {data?.label ? (
                                                      <label className="datePickerLabel text-left w-100">
                                                          {data.label}
                                                      </label>
                                                  ) : null}
                                                  <CKEditor
                                                      config={{
                                                          allowedContent: true,
                                                          fullPage: true,
                                                          extraAllowedContent:
                                                              'body[*];',
                                                          height: data.height
                                                              ? data.height
                                                              : '450px',
                                                          extraPlugins:
                                                              data.height
                                                                  ? false
                                                                  : [
                                                                        'autogrow',
                                                                        'font',
                                                                    ],
                                                          fontsize_Sizes:
                                                              '8px;10px;20px',
                                                          autoGrow_bottomSpace:
                                                              data.height
                                                                  ? false
                                                                  : 50,
                                                          removePlugins:
                                                              data.height
                                                                  ? false
                                                                  : 'resize',
                                                          contentsLangDirection:
                                                              data?.contentsLangDirection
                                                                  ? data?.contentsLangDirection
                                                                  : 'ltr',
                                                      }}
                                                      type="classic"
                                                      initData={
                                                          formik.values[
                                                              data.name
                                                          ]
                                                      }
                                                      onChange={(
                                                          event,
                                                          editor
                                                      ) => {
                                                          formik.setFieldValue(
                                                              data.name,
                                                              event.editor.getData()
                                                          )
                                                      }}
                                                      disableEnforceFocus
                                                      onInstanceReady={({
                                                          editor,
                                                      }) => {
                                                          editor.setData(
                                                              formik.values[
                                                                  data.name
                                                              ]
                                                          )
                                                      }}
                                                  />
                                                  <div className="checkboxError">
                                                      <FormHelperText>
                                                          {formik.errors[
                                                              data.name
                                                          ] &&
                                                              formik.touched[
                                                                  data.name
                                                              ] &&
                                                              formik.errors[
                                                                  data.name
                                                              ]}
                                                      </FormHelperText>
                                                  </div>
                                              </>
                                          )
                                      } catch (e) {
                                          // ckeditor4-react not installed, return null
                                          return null
                                      }
                                  })()}
                              </>
                          ) : data.type === 'advancedEditor' ? (
                              <>
                                  {data?.label ? (
                                      <label className="datePickerLabel text-left w-100">
                                          {data.label}
                                      </label>
                                  ) : null}
                                  <EmailEditor
                                      reload={data.reload}
                                      data={data}
                                      formik={formik}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                  />
                                  <div className="checkboxError">
                                      <FormHelperText>
                                          {formik.errors[data.name] &&
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]}
                                      </FormHelperText>
                                  </div>
                              </>
                          ) : data.type === 'password_checker' ? (
                              <>
                                  <PasswordStrength
                                      data={data}
                                      field={
                                          data.field ? data.field : 'password'
                                      }
                                  />
                              </>
                          ) : data.type === 'date' ? (
                              data.upperLabel ? (
                                  <DemoContainer components={['DatePicker']}>
                                      <label className="datePickerLabel">
                                          {data.label}
                                      </label>
                                      <DatePicker
                                          margin="0"
                                          autoOk={true}
                                          showTodayButton={true}
                                          id={data.name}
                                          name={data.name}
                                          variant="outlined"
                                          format={
                                              data.customDateFormat ||
                                              dateFormat
                                          }
                                          placeholder={data.placeholder || ''}
                                          disabled={data.disabled}
                                          disableFuture={
                                              data.disableFuture || false
                                          }
                                          disablePast={
                                              data.disablePast || false
                                          }
                                          maxDate={
                                              data.maxDate ||
                                              moment('2100-01-01')
                                          }
                                          maxDateMessage={
                                              data.maxDateMessage ||
                                              'Date should not be after maximal date'
                                          }
                                          minDate={
                                              data.minDate ||
                                              moment('1900-01-01')
                                          }
                                          minDateMessage={
                                              data.minDateMessage ||
                                              'Date should not be before minimal date'
                                          }
                                          className={`customDatepicker ${
                                              helperText(data, formik)
                                                  ? 'Mui-error'
                                                  : ''
                                          }`}
                                          // inputValue={
                                          //     data.filter
                                          //         ? formik.values.filters[data.name].value ||
                                          //           null
                                          //         : formik.values[data.name] || null
                                          // }
                                          value={
                                              data.filter
                                                  ? formik.values.filters[
                                                        data.name
                                                    ].value
                                                      ? moment(
                                                            formik.values
                                                                .filters[
                                                                data.name
                                                            ].value,
                                                            dateFormat
                                                        )
                                                      : null
                                                  : formik.values[data.name]
                                                  ? moment(
                                                        formik.values[data.name]
                                                    )
                                                  : null
                                          }
                                          onChange={(val) => {
                                              data.filter
                                                  ? formik.setFieldValue(
                                                        `filters.${data.name}.value`,
                                                        converDate(val, data)
                                                    )
                                                  : formik.setFieldValue(
                                                        data.name,
                                                        converDate(val, data)
                                                    )
                                          }}
                                          KeyboardButtonProps={{
                                              'aria-label': 'change date',
                                          }}
                                          //   error={
                                          //       formik.touched[data.name] &&
                                          //       formik.errors[data.name]
                                          //   }
                                          helperText={
                                              helperText(data, formik)
                                                  ? helperText(data, formik)
                                                  : data.helperText
                                          }
                                          size={data.size}
                                          slotProps={{
                                              textField: {
                                                  helperText: helperText(
                                                      data,
                                                      formik
                                                  )
                                                      ? helperText(data, formik)
                                                      : data.helperText,
                                              },
                                          }}
                                      />
                                  </DemoContainer>
                              ) : (
                                  <DemoContainer components={['DatePicker']}>
                                      <>
                                          <DatePicker
                                              margin="0"
                                              autoOk={true}
                                              showTodayButton={true}
                                              id={data.name}
                                              name={data.name}
                                              label={data.label}
                                              variant="outlined"
                                              format={
                                                  data.customDateFormat ||
                                                  dateFormat
                                              }
                                              placeholder={
                                                  data.placeholder || ''
                                              }
                                              disabled={data.disabled}
                                              disableFuture={
                                                  data.disableFuture || false
                                              }
                                              disablePast={
                                                  data.disablePast || false
                                              }
                                              maxDate={
                                                  data.maxDate ||
                                                  moment('2100-01-01')
                                              }
                                              maxDateMessage={
                                                  data.maxDateMessage ||
                                                  'Date should not be after maximal date'
                                              }
                                              minDate={
                                                  data.minDate ||
                                                  moment('1900-01-01')
                                              }
                                              minDateMessage={
                                                  data.minDateMessage ||
                                                  'Date should not be before minimal date'
                                              }
                                              className={`customDatepicker ${
                                                  helperText(data, formik)
                                                      ? 'Mui-error'
                                                      : ''
                                              }`}
                                              // inputValue={
                                              //     data.filter
                                              //         ? formik.values.filters[data.name].value ||
                                              //           null
                                              //         : formik.values[data.name] || null
                                              // }
                                              value={
                                                  data.filter
                                                      ? formik.values.filters[
                                                            data.name
                                                        ].value
                                                          ? moment(
                                                                formik.values
                                                                    .filters[
                                                                    data.name
                                                                ].value,
                                                                dateFormat
                                                            )
                                                          : null
                                                      : formik.values[data.name]
                                                      ? moment(
                                                            formik.values[
                                                                data.name
                                                            ],
                                                            dateFormat
                                                        )
                                                      : null
                                              }
                                              onChange={(val) => {
                                                  data.filter
                                                      ? formik.setFieldValue(
                                                            `filters.${data.name}.value`,
                                                            converDate(
                                                                val,
                                                                data
                                                            )
                                                        )
                                                      : formik.setFieldValue(
                                                            data.name,
                                                            converDate(
                                                                val,
                                                                data
                                                            )
                                                        )
                                              }}
                                              KeyboardButtonProps={{
                                                  'aria-label': 'change date',
                                              }}
                                              //   error={
                                              //       formik.touched[data.name] &&
                                              //       formik.errors[data.name]
                                              //   }
                                              helperText={
                                                  helperText(data, formik)
                                                      ? helperText(data, formik)
                                                      : data.helperText
                                              }
                                              size={data.size}
                                              slotProps={{
                                                  textField: {
                                                      helperText: helperText(
                                                          data,
                                                          formik
                                                      )
                                                          ? helperText(
                                                                data,
                                                                formik
                                                            )
                                                          : data.helperText,
                                                  },
                                              }}
                                          />
                                      </>
                                  </DemoContainer>
                              )
                          ) : data.type == 'multidate' ? (
                              <>
                                  <div className="mb-4">
                                      <span className="d-block text-left">
                                          {data.label}:
                                      </span>
                                      <Calendar
                                          multiple
                                          minDate={new Date()}
                                          value={formik.values[data.name]}
                                          onChange={(val) => {
                                              formik.setFieldValue(
                                                  data.name,
                                                  val
                                              )
                                          }}
                                      />
                                  </div>
                              </>
                          ) : data.type === 'dateWithCustomPicker' ? (
                              <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                      margin="0"
                                      autoOk={true}
                                      showTodayButton={
                                          typeof data.showTodayButton ===
                                          'boolean'
                                              ? data.showTodayButton
                                              : true
                                      }
                                      id={data.name}
                                      name={data.name}
                                      open={data.open}
                                      onOpen={data.onOpen ? data.onOpen : null}
                                      onClose={
                                          data.onClose ? data.onClose : null
                                      }
                                      variant="outlined"
                                      label={data.label}
                                      format={dateFormat}
                                      disabled={data.disabled}
                                      disableFuture={
                                          data.disableFuture || false
                                      }
                                      disablePast={data.disablePast || false}
                                      maxDate={
                                          data.maxDate || moment('01-01-2100')
                                      }
                                      maxDateMessage={
                                          data.maxDateMessage ||
                                          'Date should not be after maximal date'
                                      }
                                      minDate={
                                          data.minDate || moment('01-01-1900')
                                      }
                                      minDateMessage={
                                          data.minDateMessage ||
                                          'Date should not be before minimal date'
                                      }
                                      className="customDatepicker"
                                      //   inputValue={
                                      //       data.filter
                                      //           ? formik.values.filters[data.name]
                                      //                 .value || null
                                      //           : formik.values[data.name] || null
                                      //   }
                                      //   value={moment(
                                      //       formik.values[data.name],
                                      //       yearFormat
                                      //   )}
                                      //   value={moment(
                                      //       formik.values[data.name],
                                      //       dateFormat
                                      //   )}
                                      //   onChange={(val) => {
                                      //       console.log(val, data.name)
                                      //       formik.setFieldValue(
                                      //           data.name,
                                      //           converDate(val)
                                      //       )
                                      //   }}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                                  ? moment(
                                                        formik.values.filters[
                                                            data.name
                                                        ].value,
                                                        dateFormat
                                                    )
                                                  : null
                                              : formik.values[data.name]
                                              ? moment(
                                                    formik.values[data.name],
                                                    dateFormat
                                                )
                                              : null
                                      }
                                      onChange={(val) => {
                                          data.filter
                                              ? formik.setFieldValue(
                                                    `filters.${data.name}.value`,
                                                    converDate(val)
                                                )
                                              : formik.setFieldValue(
                                                    data.name,
                                                    converDate(val)
                                                )
                                      }}
                                      KeyboardButtonProps={{
                                          'aria-label': 'change date',
                                      }}
                                      error={
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      size={data.size}
                                      shouldDisableDate={(date) => {
                                          return data.shouldDisableDate
                                              ? shouldDisableDate(date, data)
                                              : data.shouldEnableDate
                                              ? shouldEnableDate(date, data)
                                              : false
                                      }}
                                  />
                              </DemoContainer>
                          ) : data.type === 'month' ? (
                              <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                      margin="0"
                                      autoOk={true}
                                      openTo="month"
                                      views={['year', 'month']}
                                      showTodayButton={true}
                                      id={data.name}
                                      name={data.name}
                                      variant="outlined"
                                      label={data.label}
                                      disablePast={data.disablePast || false}
                                      maxDate={
                                          data.maxDate ||
                                          moment('01-01-2100').format(
                                              dateFormat
                                          )
                                      }
                                      maxDateMessage={
                                          data.maxDateMessage ||
                                          'Date should not be after maximal date'
                                      }
                                      minDate={
                                          data.minDate ||
                                          moment('01-01-1900').format(
                                              dateFormat
                                          )
                                      }
                                      minDateMessage={
                                          data.minDateMessage ||
                                          'Date should not be before minimal date'
                                      }
                                      format={monthFormat}
                                      disabled={data.disabled}
                                      className="customDatepicker"
                                      //   inputValue={formik.values[data.name]}
                                      value={moment(
                                          formik.values[data.name],
                                          yearFormat
                                      )}
                                      onChange={(val) => {
                                          formik.setFieldValue(
                                              data.name,
                                              moment(val).format(yearFormat)
                                          )
                                      }}
                                      KeyboardButtonProps={{
                                          'aria-label': 'change date',
                                      }}
                                      error={
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                  />
                              </DemoContainer>
                          ) : data.type === 'datetime' ? (
                              <DemoContainer components={['DateTimePicker']}>
                                  <DateTimePicker
                                      ampm={global?.no_ampm ? false : true}
                                      margin="0"
                                      autoOk={
                                          data.autoOk === false ? false : true
                                      }
                                      showTodayButton={
                                          typeof data.showTodayButton ===
                                          'boolean'
                                              ? data.showTodayButton
                                              : true
                                      }
                                      id={data.name}
                                      name={data.name}
                                      variant="outlined"
                                      label={data.label}
                                      format={dateTimeFormat}
                                      disabled={data.disabled}
                                      disablePast={data.disablePast || false}
                                      strictCompareDates={
                                          data.strictCompareDates || false
                                      }
                                      maxDate={
                                          moment(
                                              data.maxDate,
                                              dateTimeFormat
                                          ) || moment('01/01/2100')
                                      }
                                      maxDateMessage={
                                          data.maxDateMessage ||
                                          'Date should not be after maximal date'
                                      }
                                      minDate={
                                          moment(
                                              data.minDate,
                                              dateTimeFormat
                                          ) || moment('01/01/1900')
                                      }
                                      minDateMessage={
                                          data.minDateMessage ||
                                          'Date should not be before minimal date'
                                      }
                                      className={`customDatepicker ${
                                          helperText(data, formik)
                                              ? 'Mui-error'
                                              : ''
                                      }`}
                                      //   inputValue={
                                      //       data.table_search
                                      //           ? formik.values.filters[data.name]
                                      //                 .value
                                      //           : formik.values[data.name]
                                      //   }
                                      value={
                                          formik.values[data.name]
                                              ? moment(
                                                    formik.values[data.name],
                                                    dateTimeFormat
                                                )
                                              : null
                                      }
                                      onChange={(val) => {
                                          formik.setFieldValue(
                                              data.name,
                                              moment(val).format(dateTimeFormat)
                                          )
                                      }}
                                      KeyboardButtonProps={{
                                          'aria-label': 'change date',
                                      }}
                                      error={
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      slotProps={{
                                          textField: {
                                              helperText: helperText(
                                                  data,
                                                  formik
                                              )
                                                  ? helperText(data, formik)
                                                  : data.helperText,
                                          },
                                      }}
                                      componentsProps={{
                                          inputAdornment: {
                                              position: data.icon_only
                                                  ? 'start'
                                                  : 'end',
                                          },

                                          textField: {
                                              InputProps: {
                                                  readOnly: data.icon_only
                                                      ? true
                                                      : false,
                                              },
                                          },
                                      }}
                                  />
                              </DemoContainer>
                          ) : data.type === 'year' ? (
                              <DemoContainer components={['DatePicker']}>
                                  <DateTimePicker
                                      margin="0"
                                      //   autoOk={true}
                                      id={data.name}
                                      openTo="year"
                                      views={['year']}
                                      name={data.name}
                                      label={data.label}
                                      variant="outlined"
                                      format={yearFormat}
                                      placeholder={data.placeholder || ''}
                                      disabled={data.disabled}
                                      disableFuture={
                                          data.disableFuture || false
                                      }
                                      disablePast={data.disablePast || false}
                                      //   maxDate={
                                      //       data.maxDate ||
                                      //       moment('01-01-2100').format(
                                      //           dateFormat
                                      //       )
                                      //   }
                                      //   maxDateMessage={
                                      //       data.maxDateMessage ||
                                      //       'Date should not be after maximal date'
                                      //   }
                                      //   minDate={
                                      //       data.minDate ||
                                      //       moment('01-01-1900').format(
                                      //           dateFormat
                                      //       )
                                      //   }
                                      //   minDateMessage={
                                      //       data.minDateMessage ||
                                      //       'Date should not be before minimal date'
                                      //   }
                                      className="customDatepicker"
                                      //   inputValue={
                                      //       data.filter
                                      //           ? formik.values.filters[data.name]
                                      //                 .value || null
                                      //           : formik.values[data.name] || null
                                      //   }
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                                  ? moment(
                                                        formik.values.filters[
                                                            data.name
                                                        ].value,
                                                        yearFormat
                                                    )
                                                  : null
                                              : formik.values[data.name]
                                              ? moment(
                                                    formik.values[data.name],
                                                    yearFormat
                                                )
                                              : null
                                      }
                                      onChange={(val) => {
                                          data.filter
                                              ? formik.setFieldValue(
                                                    `filters.${data.name}.value`,
                                                    moment(val).format(
                                                        yearFormat
                                                    )
                                                )
                                              : formik.setFieldValue(
                                                    data.name,
                                                    moment(val).format(
                                                        yearFormat
                                                    )
                                                )
                                      }}
                                      //   KeyboardButtonProps={{
                                      //       'aria-label': 'change date',
                                      //   }}
                                      slotProps={{
                                          textField: {
                                              helperText: helperText(
                                                  data,
                                                  formik
                                              )
                                                  ? helperText(data, formik)
                                                  : data.helperText,
                                              error:
                                                  formik.touched[data.name] &&
                                                  formik.errors[data.name],
                                              fullWidth: true,
                                          },
                                      }}
                                      //   onError={
                                      //       formik.touched[data.name] &&
                                      //       formik.errors[data.name]
                                      //   }

                                      //   helperText={
                                      //       helperText(data, formik)
                                      //           ? helperText(data, formik)
                                      //           : data.helperText
                                      //   }
                                      size={data.size}
                                  />
                              </DemoContainer>
                          ) : data.type === 'time' ? (
                              <DemoContainer components={['TimePicker']}>
                                  <>
                                      <TimePicker
                                          margin="0"
                                          autoOk={true}
                                          id={data.name}
                                          name={data.name}
                                          variant="outlined"
                                          format={timeFormat}
                                          label={data.label}
                                          disabled={data.disabled}
                                          disablePast={
                                              data.disablePast || false
                                          }
                                          className="customDatepicker"
                                          //   inputValue={formik.values[data.name]}
                                          value={
                                              formik.values[data.name]
                                                  ? moment(
                                                        formik.values[
                                                            data.name
                                                        ],
                                                        timeFormat
                                                    )
                                                  : null
                                          }
                                          onChange={(val) => {
                                              data.filter || data.table_search
                                                  ? formik.setFieldValue(
                                                        `filters.${data.name}.value`,
                                                        moment(val).format(
                                                            timeFormat
                                                        )
                                                    )
                                                  : formik.setFieldValue(
                                                        data.name,
                                                        moment(val).format(
                                                            timeFormat
                                                        )
                                                    )
                                          }}
                                          KeyboardButtonProps={{
                                              'aria-label': 'change time',
                                          }}
                                          error={
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]
                                          }
                                          helperText={
                                              formik.errors[data.name] &&
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]
                                          }
                                          slotProps={{
                                              textField: {
                                                  helperText: helperText(
                                                      data,
                                                      formik
                                                  )
                                                      ? helperText(data, formik)
                                                      : data.helperText,
                                              },
                                          }}
                                      />
                                  </>
                              </DemoContainer>
                          ) : data.type === 'textarea' ? (
                              <>
                                  <CustomTextArea
                                      id={data.id}
                                      value={formik.values[data.name]}
                                      autoFocus={data.autoFocus}
                                      name={data.name}
                                      disabled={data.disabled}
                                      shrink={formik.values[data.name] && true}
                                      onBlur={formik.handleBlur}
                                      onChange={
                                          data.onChange
                                              ? data.onChange
                                              : formik.handleChange
                                      }
                                      label={data.label}
                                      placeholder={data.placeholder}
                                      rowsMax={data.rowsMax}
                                      rows={data.rows}
                                      type={data.type}
                                      upperLabel={data.upperLabel}
                                      error={
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                  />
                              </>
                          ) : data.type === 'checkbox' ? (
                              <>
                                  <CheckBox
                                      checked={formik.values[data.name]}
                                      label={data.label}
                                      value={true}
                                      customized={data.customized}
                                      disabled={data.disabled}
                                      onChange={() => {
                                          formik.setFieldValue(
                                              data.name,
                                              !formik.values[data.name]
                                          )
                                      }}
                                      name={data.name}
                                      error={
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                  />
                              </>
                          ) : data.type === 'checkboxarray' ? (
                              <>
                                  {data?.label ? (
                                      <label className="datePickerLabel text-left w-100">
                                          {data.label}
                                      </label>
                                  ) : null}
                                  {data.item.map((d, i) => (
                                      <>
                                          <CheckBox
                                              name={data.name}
                                              label={d.description}
                                              checked={
                                                  formik.values[
                                                      data.name
                                                  ].indexOf(d.id.toString()) !==
                                                  -1
                                                      ? true
                                                      : false
                                              }
                                              disabled={d.disabled || false}
                                              value={d.id.toString()}
                                              onChange={formik.handleChange}
                                          />
                                      </>
                                  ))}
                              </>
                          ) : data.type === 'google_place_autocomplete' ? (
                              <>
                                  <GooglePlaceAutoComplete
                                      id={data.id}
                                      name={data.name}
                                      value={formik.values[data.name]}
                                      formik={formik}
                                      label={data.label}
                                      googlePlaceType={data.googlePlaceType}
                                      error={
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      placeID={data.placeID}
                                      fullAddress={data.fullAddress}
                                      defaultCountry={data.defaultCountry}
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                  />
                              </>
                          ) : data.type === 'radio' ? (
                              <>
                                  <RadioBox
                                      error={
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      helperText={
                                          formik.errors[data.name] &&
                                          formik.touched[data.name] &&
                                          formik.errors[data.name]
                                      }
                                      title={data.title}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      items={data.item || data.options}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                              : formik.values[data.name]
                                      }
                                      onChange={formik.handleChange}
                                      int={data.int}
                                      disabled={data.disabled}
                                  />
                              </>
                          ) : data.type === 'mask' ? (
                              <>
                                  <CustomMaskInput
                                      id={data.id}
                                      maskValue={data.maskValue}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                              : formik.values[data.name]
                                      }
                                      autoFocus={data.autoFocus}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      disabled={data.disabled}
                                      shrink={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                                  ? true
                                                  : false
                                              : formik.values[data.name]
                                              ? true
                                              : false
                                      }
                                      onBlur={formik.handleBlur}
                                      onChange={
                                          data.onChange
                                              ? data.onChange
                                              : formik.handleChange
                                      }
                                      label={data.label}
                                      placeholder={data.placeholder}
                                      type={data.type}
                                      variant={data.variant}
                                      size={data.size}
                                      startAdornment={data.startAdornment}
                                      endAdornment={data.endAdornment}
                                      error={errorCheck(data, formik)}
                                      helperText={
                                          helperText(data, formik)
                                              ? helperText(data, formik)
                                              : data.helperText
                                      }
                                      inputStyle={data.inputStyle}
                                      upperLabel={data.upperLabel}
                                      tooltiptitle={data.tooltiptitle}
                                  />
                              </>
                          ) : data.type === 'multipleArrayValue' ? (
                              <>
                                  <MultipleArray
                                      data={data}
                                      formik={formik}
                                      id={data.id}
                                      error={errorCheck(data, formik)}
                                      helperText={
                                          helperText(data, formik)
                                              ? helperText(data, formik)
                                              : data.helperText
                                      }
                                  />
                              </>
                          ) : data.type === 'hiddenMask' ? (
                              <>
                                  <CustomMaskInputWithHidden
                                      id={data.id}
                                      maskValue={data.maskValue}
                                      value={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                              : formik.values[data.name]
                                      }
                                      autoFocus={data.autoFocus}
                                      name={
                                          data.filter
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      disabled={data.disabled}
                                      shrink={
                                          data.filter
                                              ? formik.values.filters[data.name]
                                                    .value
                                                  ? true
                                                  : false
                                              : formik.values[data.name]
                                              ? true
                                              : false
                                      }
                                      onBlur={formik.handleBlur}
                                      onChange={
                                          data.onChange
                                              ? data.onChange
                                              : formik.handleChange
                                      }
                                      label={data.label}
                                      placeholder={data.placeholder}
                                      type={data.type}
                                      variant={data.variant}
                                      size={data.size}
                                      startAdornment={data.startAdornment}
                                      endAdornment={data.endAdornment}
                                      error={errorCheck(data, formik)}
                                      helperText={
                                          helperText(data, formik)
                                              ? helperText(data, formik)
                                              : data.helperText
                                      }
                                      inputStyle={data.inputStyle}
                                      upperLabel={data.upperLabel}
                                      tooltiptitle={data.tooltiptitle}
                                      modal={
                                          data.modalPP ? data.modalPP : false
                                      }
                                      last4Masked={
                                          data?.last4Masked ? true : false
                                      }
                                  />
                              </>
                          ) : data.type === 'otpInput' ? (
                              <div className="otpInputCnt">
                                  <OtpInput
                                      value={
                                          data.value
                                              ? data.value
                                              : formik.values[data.name]
                                      }
                                      onChange={(val) => {
                                          formik.setFieldValue(data.name, val)
                                      }}
                                      numInputs={
                                          data.inputCount ? data.inputCount : 6
                                      }
                                      separator={
                                          data.separator ? (
                                              data.separator
                                          ) : (
                                              <span>-</span>
                                          )
                                      }
                                      containerStyle="otpInput"
                                      isDisabled={
                                          data.isDisabled
                                              ? data.isDisabled
                                              : false
                                      }
                                      isInputSecure={
                                          data.isInputSecure
                                              ? data.isInputSecure
                                              : false
                                      }
                                      shouldAutoFocus={
                                          data.shouldAutoFocus
                                              ? data.shouldAutoFocus
                                              : false
                                      }
                                      placeholder={
                                          data.placeholder
                                              ? data.placeholder
                                              : ''
                                      }
                                      renderInput={(props) => (
                                          <input {...props} />
                                      )}
                                  />
                                  <div className="checkboxError">
                                      <FormHelperText>
                                          {formik.errors[data.name] &&
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]}
                                      </FormHelperText>
                                  </div>
                              </div>
                          ) : data.type === 'colorpicker' ? (
                              <>
                                  {data?.label ? (
                                      <div className="datePickerLabelCnt d-flex justify-content-between w-100">
                                          <label className="datePickerLabel text-left">
                                              {data.label}
                                          </label>
                                          <Button
                                              onClick={() =>
                                                  formik.setFieldValue(
                                                      data.name,
                                                      ''
                                                  )
                                              }
                                              variant="outlined"
                                          >
                                              <span className="material-icons">
                                                  clear
                                              </span>
                                              Clear
                                          </Button>
                                      </div>
                                  ) : null}
                                  <TwitterPicker
                                      colors={
                                          data.defaultColors || [
                                              '#FF6900',
                                              '#FCB900',
                                              '#7BDCB5',
                                              '#8ED1FC',
                                              '#0693E3',
                                              '#ABB8C3',
                                              '#EB144C',
                                              '#F78DA7',
                                              '#9900EF',
                                          ]
                                      }
                                      color={formik.values[data.name]}
                                      onChangeComplete={(color) =>
                                          formik.setFieldValue(
                                              data.name,
                                              color.hex
                                          )
                                      }
                                  />
                                  <div className="checkboxError">
                                      <FormHelperText>
                                          {formik.errors[data.name] &&
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]}
                                      </FormHelperText>
                                  </div>
                              </>
                          ) : data.type === 'captcha' ? (
                              <>
                                  <GoogleCaptch
                                      data={data}
                                      formik={formik}
                                      id={data.id}
                                      error={errorCheck(data, formik)}
                                      helperText={
                                          helperText(data, formik)
                                              ? helperText(data, formik)
                                              : data.helperText
                                      }
                                  />
                              </>
                          ) : data.type === 'tinymce' ? (
                              <>
                                  {data?.label ? (
                                      <label className="datePickerLabel text-left w-100">
                                          {data.label}
                                      </label>
                                  ) : null}
                                  <TINYMCE
                                      //initialValue={formik.values[data.name]}
                                      value={formik.values?.[data.name] || ''}
                                      // SECURITY-REVIEWED (see docs/SECURITY_ACCEPTED_FINDINGS.md #2):
                                      // TinyMCE cloud key only identifies
                                      // which plan/quota/domain-allowlist to
                                      // bill against - not a secret. (A
                                      // real, hardcoded key used to sit here
                                      // in a dead comment - removed.)
                                      apiKey={process.env.REACT_APP_TINYMCEKEY}
                                      init={{
                                          plugins:
                                              data?.version === 'free'
                                                  ? [
                                                        'print',
                                                        'preview',
                                                        'importcss',
                                                        'searchreplace',
                                                        'autolink',
                                                        'directionality',
                                                        'visualblocks',
                                                        'visualchars',
                                                        'fullscreen',
                                                        'image',
                                                        'link',
                                                        'media',
                                                        //'template',
                                                        'codesample',
                                                        'table',
                                                        'charmap',
                                                        'hr',
                                                        'pagebreak',
                                                        'nonbreaking',
                                                        'anchor',
                                                        'toc',
                                                        'insertdatetime',
                                                        'advlist',
                                                        'lists',
                                                        'wordcount',
                                                        'imagetools',
                                                        'textpattern',
                                                        'noneditable',
                                                        'help',
                                                        'quickbars',
                                                        'linkchecker',
                                                        'emoticons',
                                                        'code',
                                                    ]
                                                  : data?.version ===
                                                    'professional'
                                                  ? [
                                                        'print',
                                                        'preview',
                                                        'casechange',
                                                        'importcss',
                                                        'searchreplace',
                                                        'autolink',
                                                        'directionality',
                                                        'advcode',
                                                        'visualblocks',
                                                        'visualchars',
                                                        'fullscreen',
                                                        'image',
                                                        'link',
                                                        'media',
                                                        'mediaembed',
                                                        'template',
                                                        'codesample',
                                                        'table',
                                                        'charmap',
                                                        'hr',
                                                        'pagebreak',
                                                        'nonbreaking',
                                                        'anchor',
                                                        'toc',
                                                        'insertdatetime',
                                                        'advlist',
                                                        'lists',
                                                        'checklist',
                                                        'wordcount',
                                                        'a11ychecker',
                                                        'imagetools',
                                                        'textpattern',
                                                        'noneditable',
                                                        'help',
                                                        'formatpainter',
                                                        'permanentpen',
                                                        'pageembed',
                                                        'mentions',
                                                        'quickbars',
                                                        'linkchecker',
                                                        'emoticons',
                                                        'advtable',
                                                        'export',
                                                        'code',
                                                        'spellchecker',
                                                        'accessibilitychecker',
                                                        'powerpaste',
                                                    ].filter(
                                                        (p) =>
                                                            !TINYMCE_PREMIUM_DISABLED ||
                                                            ![
                                                                'a11ychecker',
                                                                'accessibilitychecker',
                                                                'powerpaste',
                                                            ].includes(p)
                                                    )
                                                  : [
                                                        'print',
                                                        'preview',
                                                        // 'powerpaste',
                                                        'casechange',
                                                        'importcss',
                                                        'searchreplace',
                                                        'autolink',
                                                        'directionality',
                                                        'advcode',
                                                        'visualblocks',
                                                        'visualchars',
                                                        'fullscreen',
                                                        'image',
                                                        'link',
                                                        'media',
                                                        'mediaembed',
                                                        //'template',
                                                        'codesample',
                                                        'table',
                                                        'charmap',
                                                        'hr',
                                                        'pagebreak',
                                                        'nonbreaking',
                                                        'anchor',
                                                        'toc',
                                                        'insertdatetime',
                                                        'advlist',
                                                        'lists',
                                                        'checklist',
                                                        'wordcount',
                                                        'imagetools',
                                                        'textpattern',
                                                        'noneditable',
                                                        'help',
                                                        'formatpainter',
                                                        'permanentpen',
                                                        'pageembed',
                                                        'mentions',
                                                        'quickbars',
                                                        'linkchecker',
                                                        'emoticons',
                                                        'advtable',
                                                        'export',
                                                        'code',
                                                        'spellchecker',
                                                        'accessibilitychecker',
                                                    ].filter(
                                                        (p) =>
                                                            !TINYMCE_PREMIUM_DISABLED ||
                                                            ![
                                                                'a11ychecker',
                                                                'accessibilitychecker',
                                                                'powerpaste',
                                                            ].includes(p)
                                                    ),
                                          menubar:
                                              'file edit view insert format tools table tc help',
                                          toolbar:
                                              'undo redo | bold italic underline strikethrough | fontselect insert styleselect | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist checklist | forecolor backcolor casechange permanentpen removeformat| pagebreak | charmap emoticons | fullscreen preview print | insertfile image media pageembed link anchor codesample | a11ycheck ltr rtl'.replace(
                                                  TINYMCE_PREMIUM_DISABLED
                                                      ? ' a11ycheck'
                                                      : '',
                                                  ''
                                              ),
                                          // | insert | styleselect | casechange blocks | bold italic forecolor backcolor | bullist numlist checklist outdent indent | removeformat | allycheck code table | link image code',
                                          quickbars_selection_toolbar:
                                              'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                                          toolbar_mode: 'sliding',
                                          spellchecker_ignore_list: [
                                              'Ephox',
                                              'Moxiecode',
                                          ],
                                          contextmenu:
                                              'link image imagetools table configurepermanentpen',
                                          content_style: '',
                                          powerpaste_allow_local_images: true,
                                          powerpaste_word_import: 'prompt',
                                          powerpaste_html_import: 'prompt',
                                          images_upload_handler:
                                              tinyMCEImageUpload,
                                      }}
                                      /* onEditorChange={(nexTxt, editor) => {
                          if (nexTxt) {
                              clearTimeout(tinymceEditorChangeHandler)
                              tinymceEditorChangeHandler = setTimeout(() => {
                                  formik.setFieldValue(data.name, nexTxt)
                                  editor.focus()
                                  editor.selection.select(editor.getBody(), true)
                                  editor.selection.collapse(false)
                              }, 1000)
                          }
                      }} */
                                      onEditorChange={(event, editor) => {
                                          data.onChange
                                              ? data.onChange(event, editor)
                                              : formik.setFieldValue(
                                                    data.name,
                                                    editor.getContent() || ' '
                                                )
                                      }}
                                  />

                                  <div className="checkboxError">
                                      <FormHelperText>
                                          {formik.errors[data.name] &&
                                              formik.touched[data.name] &&
                                              formik.errors[data.name]}
                                      </FormHelperText>
                                  </div>
                              </>
                          ) : (
                              <>
                                  <CustomInput
                                      id={data.id}
                                      value={
                                          data.filter || data.table_search
                                              ? formik?.values?.filters?.[
                                                    data.name
                                                ]?.value
                                                  ? formik.values.filters[
                                                        data.name
                                                    ].value
                                                  : ''
                                              : formik.values[data.name]
                                      }
                                      autoFocus={data.autoFocus}
                                      autoComplete={data?.autoComplete}
                                      scanBarcode={data.scanBarcode}
                                      triggerPasteEvent={data.triggerPasteEvent}
                                      forcedAutoFocus={data.forcedAutoFocus}
                                      forcedAutoFocusUpdateDependency={
                                          data.forcedAutoFocusUpdateDependency
                                      }
                                      name={
                                          data.filter || data.table_search
                                              ? `filters.${data.name}.value`
                                              : data.name
                                      }
                                      disabled={data.disabled}
                                      shrink={
                                          data.filter || data.table_search
                                              ? formik?.values?.filters?.[
                                                    data.name
                                                ]?.value
                                                  ? formik.values.filters[
                                                        data.name
                                                    ].value
                                                      ? true
                                                      : false
                                                  : false
                                              : formik.values[data.name]
                                              ? true
                                              : false
                                      }
                                      onBlur={formik.handleBlur}
                                      onChange={
                                          data.onChange
                                              ? data.onChange
                                              : formik.handleChange
                                      }
                                      label={data.label}
                                      placeholder={data.placeholder}
                                      type={data.type}
                                      variant={data.variant}
                                      size={data.size}
                                      startAdornment={data.startAdornment}
                                      maxLength={data.maxLength}
                                      maxDecimal={data.maxDecimal}
                                      endAdornment={data.endAdornment}
                                      error={errorCheck(data, formik)}
                                      helperText={
                                          helperText(data, formik)
                                              ? helperText(data, formik)
                                              : data.helperText
                                      }
                                      inputStyle={data.inputStyle}
                                      upperLabel={data.upperLabel}
                                      tooltiptitle={data.tooltiptitle}
                                      readonly={data.readonly}
                                      formik={formik}
                                      capitalize={data.capitalize}
                                      propercase={data.propercase}
                                      enableAutofillCheck={
                                          data.enableAutofillCheck
                                      }
                                      showCounter={data.showCounter}
                                      counterLimit={data.counterLimit}
                                      onWheel={
                                          data.type === 'number'
                                              ? true
                                              : data.onWheel || false
                                      }
                                  />
                              </>
                          )}
                      </div>
                  </>
              ))
            : null
    return data
}

export const handleRedirectInternal = (history, path) => {
    history.push(`/${path}`)
    window.scrollTo(0, 0)
}

export const dateFormatFront = (data) => {
    return moment(data).isValid()
        ? `${moment(data).format('MMM Do')}, ${moment(data).format('h:mm a')}`
        : '-'
}

export const dateFormatFrontDay = (data) => {
    return `${moment(data).format('MMM Do YYYY')}`
}

export const dateFormatFrontTime = (data) => {
    return `${moment(data).format('h:mm a')}`
}

export const checkProductOpen = (date_added, user_role) => {
    let startDate = new Date(serverTime)
    let addDate = new Date(date_added)
    let milliSeconds = 0
    // if (parseInt(user_role) !== 3) {
    //   milliSeconds = 1 * 3600000;
    // } else {
    // }
    let incrementedTime = addDate.getTime() + parseInt(milliSeconds)
    let newaddDate = new Date(incrementedTime)
    if (newaddDate > startDate) {
        return false
        // let incrementedTime = addDate.getTime() + parseInt(milliSeconds);
        // let timerTime = incrementedTime - startDate.getTime();
        // if (timerTime <= 0) {
        //   return true;
        // } else {
        //   return false;
        // }
    } else {
        return true
    }
}

export const maskEmailFront = (data) => {
    data = data.toString()
    var first4 = data.substring(0, 4)
    var last5 = data.substring(data.length - 5)
    var mask = data.substring(4, data.length - 5).replace(/[^]/g, '*')
    return first4 + mask + last5
}

export const capitalize = (data) => {
    let dataReturn = ''
    if (data) {
        data = data.replace(/_/g, ' ').toLowerCase()
        data.split(' ')
        if (data instanceof Array) {
            dataReturn = data
                .map((word) => {
                    return word[0].toUpperCase() + word.substring(1)
                })
                .join(' ')
        } else {
            dataReturn = data.charAt(0).toUpperCase() + data.slice(1)
        }
    }
    return dataReturn
}

export const upperCase = (data) => {
    let dataReturn = ''
    if (data) {
        dataReturn = data.replace(/_/g, ' ').toUpperCase()
    }
    return dataReturn
}

export const currencyFormat = (data, locale = true) => {
    let dataReturn = '-'
    if (data) {
        if (locale) {
            if (global.currencySymbol) {
                dataReturn = `${global.currencySymbol} ${parseFloat(
                    data
                ).toLocaleString(global.currencyFormate)}`
            } else {
                dataReturn = `US $${parseFloat(data).toLocaleString('en-US')}`
            }
        } else {
            dataReturn = `US $${parseFloat(data)}`
        }
    }
    return dataReturn
}

export const currencyFormatWithDecimal = (data) => {
    let dataReturn = '-'
    if (data) {
        dataReturn = `US ${new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            style: 'currency',
            currency: 'USD',
        }).format(data)}`
    }
    return dataReturn
}

export const dateFormatFunction = (data) => {
    let dataReturn = '-'
    if (data) {
        dataReturn = `${moment(data).format(
            global.dateFormat ? global.dateFormat : dateFormat
        )}`
    }
    return dataReturn
}

export const dateTimeFormatFunction = (data, nullDefault, customFormat) => {
    let dataReturn = '-'
    if (nullDefault) {
        dataReturn = null
    }
    if (data) {
        if (global?.defaultDateTimeFormat) {
            if (moment(data).isValid()) {
                dataReturn = `${moment(data).format(
                    global?.defaultDateTimeFormat
                )}`
            }
        } else if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(
                customFormat ? customFormat : dateTimeFormat
            )}`
        }
    }
    return dataReturn
}

export const dateTimeSecondFormatFunction = (data) => {
    let dataReturn = '-'
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(dateTimeSecondFormat)}`
        }
    }
    return dataReturn
}

export const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

export const DirectAPICAll = (
    method,
    url,
    data,
    headertype,
    baseurl,
    token
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let type = ''
            if (headertype && headertype === 'formdata') {
                type = 'multipart/form-data'
            } else {
                type = 'application/json'
            }
            const config = {
                headers: {
                    'content-type': type,
                },
            }
            if (token) {
                config.headers.authorization = `Bearer ${token}`
            }

            if (method === 'get') {
                let res = await axios.get(`${url}`)
                resolve(res)
            } else if (method === 'post') {
                if (data) {
                    let res = await axios.post(`${url}`, data, config)
                    resolve(res)
                } else {
                    let res = await axios.post(`${url}`, config)
                    resolve(res)
                }
            }
        } catch (err) {
            console.log('responsode error from api', err)
            resolve(err)
        }
    })
}

export const useCustomMediaQuery = (queryString) => {
    const [isMatch, setIsMatch] = useState(false)
    const mqChange = (mq) => {
        setIsMatch(mq.matches)
    }

    useEffect(() => {
        const mq = window.matchMedia(queryString)
        mq.addListener(mqChange)
        mqChange(mq)

        return () => {
            mq.removeListener(mqChange)
        }
    }, [queryString])

    return isMatch
}

export const IndianCurrencyInWords = (inputNumber) => {
    let str = new String(inputNumber)
    let splt = str.split('')
    let rev = splt.reverse()
    let once = [
        'Zero',
        ' One',
        ' Two',
        ' Three',
        ' Four',
        ' Five',
        ' Six',
        ' Seven',
        ' Eight',
        ' Nine',
    ]
    let twos = [
        'Ten',
        ' Eleven',
        ' Twelve',
        ' Thirteen',
        ' Fourteen',
        ' Fifteen',
        ' Sixteen',
        ' Seventeen',
        ' Eighteen',
        ' Nineteen',
    ]
    let tens = [
        '',
        'Ten',
        ' Twenty',
        ' Thirty',
        ' Forty',
        ' Fifty',
        ' Sixty',
        ' Seventy',
        ' Eighty',
        ' Ninety',
    ]

    let numLength = rev.length
    let word = new Array()
    let j = 0

    for (var i = 0; i < numLength; i++) {
        switch (i) {
            case 0:
                if (rev[i] == 0 || rev[i + 1] == 1) {
                    word[j] = ''
                } else {
                    word[j] = '' + once[rev[i]]
                }
                word[j] = word[j]
                break

            case 1:
                aboveTens()
                break

            case 2:
                if (rev[i] == 0) {
                    word[j] = ''
                } else if (rev[i - 1] == 0 || rev[i - 2] == 0) {
                    word[j] = once[rev[i]] + ' Hundred '
                } else {
                    word[j] = once[rev[i]] + ' Hundred and'
                }
                break

            case 3:
                if (rev[i] == 0 || rev[i + 1] == 1) {
                    word[j] = ''
                } else {
                    word[j] = once[rev[i]]
                }
                if (rev[i + 1] != 0 || rev[i] > 0) {
                    word[j] = word[j] + ' Thousand '
                }
                break

            case 4:
                aboveTens()
                break

            case 5:
                if (rev[i] == 0 || rev[i + 1] == 1) {
                    word[j] = ''
                } else {
                    word[j] = once[rev[i]]
                }
                if (rev[i + 1] !== '0' || rev[i] > '0') {
                    word[j] = word[j] + ' Lakh '
                }

                break

            case 6:
                aboveTens()
                break

            case 7:
                if (rev[i] == 0 || rev[i + 1] == 1) {
                    word[j] = ''
                } else {
                    word[j] = once[rev[i]]
                }
                if (rev[i + 1] !== '0' || rev[i] > '0') {
                    word[j] = word[j] + ' Crore '
                }
                break

            case 8:
                aboveTens()
                break

            default:
                break
        }
        j++
    }

    function aboveTens() {
        if (rev[i] == 0) {
            word[j] = ''
        } else if (rev[i] == 1) {
            word[j] = twos[rev[i - 1]]
        } else {
            word[j] = tens[rev[i]]
        }
    }

    word.reverse()
    let finalOutput = ''
    for (i = 0; i < numLength; i++) {
        finalOutput = finalOutput + word[i]
    }
    return finalOutput
}

export const removeHTMLTags = (data) => {
    if (typeof data !== 'string') return ''
    // DOMParser-produced documents have no browsing context, so unlike a
    // plain `element.innerHTML = data` assignment, they never execute
    // scripts or fire resource-loading handlers (e.g. <img onerror=...>)
    // while extracting the text content.
    const parsedDoc = new DOMParser().parseFromString(data, 'text/html')
    return parsedDoc.body.textContent || parsedDoc.body.innerText || ''
}

export const greetingBasedOnTime = (greeting = '', message) => {
    const hour = new Date().getHours()

    if (hour < 12) {
        return (
            <div className="userGreetingCnt">
                <img
                    src="/assets/images/sunrise.png"
                    className="greetingIcon"
                    alt="Good Morning"
                />
                <h2>
                    {'Good morning, ' + greeting || ''}
                    <span className="">{message || ''}</span>
                </h2>
            </div>
        )
    } else if (hour < 18) {
        return (
            <div className="userGreetingCnt">
                <img
                    src="/assets/images/dawn.png"
                    className="greetingIcon"
                    alt="Good Afternoon"
                />
                <h2>
                    {'Good afternoon, ' + greeting || ''}
                    <span className="">{message || ''}</span>
                </h2>
            </div>
        )
    } else {
        return (
            <div className="userGreetingCnt">
                <img
                    src="/assets/images/night.png"
                    className="greetingIcon"
                    alt="Good Evening"
                />
                <h2>
                    {'Good evening, ' + greeting || ''}
                    <span className="">{message || ''}</span>
                </h2>
            </div>
        )
    }
}

export const addDaysToDate = (startDateSelected, day = 7) => {
    if (startDateSelected && day) {
        const startDate = moment(startDateSelected, 'MM-DD-YYYY hh:mm a')
        const endDate = startDate.clone().add(day, 'days')
        return endDate.toDate()
    } else {
        return startDateSelected
    }
}

export const isValidHttpUrl = (string) => {
    let url
    try {
        url = new URL(string)
    } catch (_) {
        return false
    }

    return url.protocol === 'http:' || url.protocol === 'https:'
}

export const formatDate = (inputDate) => {
    let date = new Date(inputDate)

    if (isNaN(date.getTime())) {
        const dateParts = inputDate.split(/[- T]/)
        date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
    }

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export function getPickupHours(storeInfo) {
    const days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
    ]
    let pickupHours = ''

    for (const day of days) {
        const starting = storeInfo[day + '_starting']
        const ending = storeInfo[day + '_ending']

        if (starting && ending && storeInfo[day + '_available'] !== 'closed') {
            const startTime = moment(starting, 'HH:mm:ss').format('hh:mmA')
            const endTime = moment(ending, 'HH:mm:ss').format('hh:mmA')
            pickupHours += `${
                day.charAt(0).toUpperCase() + day.slice(1)
            } - ${startTime} - ${endTime}, `
        } else {
            pickupHours += `${
                day.charAt(0).toUpperCase() + day.slice(1)
            } - Closed, `
        }
    }

    return pickupHours.slice(0, -2) // Remove the trailing comma and space
}

export const formatPhone = (phone, removeCountryCode = false) => {
    const countryCode = '+1'
    const removeCharacter = ['+1', '1', '+', '', 0, '0']
    if (removeCountryCode && removeCharacter.includes(phone)) {
        phone = ''
    } else if (
        removeCountryCode &&
        typeof phone === 'string' &&
        phone?.length
    ) {
        const regex = /\d+/g
        phone = phone.replace(/^\+?1\s?/, '')
        phone = phone.replace(/^\+/, '')
        const numbersArray = phone?.match(regex)
        const numbersString = numbersArray?.join('')
        phone = parseInt(numbersString, 10)
    } else {
        if (typeof phone === 'string' && !phone?.startsWith('+1')) {
            phone = phone ? `${countryCode}${phone}` : ''
        } else {
            phone = phone ? `${countryCode}${phone}` : ''
        }
    }
    return phone
}

export const detectFileType = (url) => {
    // Extract the file extension from the URL
    const extension = url.split('.').pop().toLowerCase()

    // Define arrays of common image and video extensions
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp']
    const videoExtensions = [
        'mp4',
        'avi',
        'mov',
        'wmv',
        'flv',
        'webm',
        'mkv',
        'm4v',
    ]

    // Check if the extension matches an image or video
    if (imageExtensions.includes(extension)) {
        return 'image'
    } else if (videoExtensions.includes(extension)) {
        return 'video'
    } else {
        return 'unknown'
    }
}

export const getSummaryFields = (data) => {
    if (!Array.isArray(data)) {
        return {}
    }

    return data.reduce(
        (result, { field, summaryField, summary, summaryType }) => {
            if (summaryField && (summary || summaryType)) {
                result[field] = {
                    summaryField,
                    summary: summary || false,
                    summaryType: summaryType || '',
                }
            }
            return result
        },
        {}
    )
}

/**
 * Cleans and formats currency input
 * @param {string} value - raw input string
 * @param {number} decimalPlaces - max decimal places
 * @returns {object} { raw: string, formatted: string }
 */
export const processAmountInput = (value, decimalPlaces = 10) => {
    if (!value) return ''

    // Remove all non-digit/non-dot characters
    let val = value.replace(/[^0-9.]/g, '')

    // Only allow one decimal
    const parts = val.split('.')
    if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('')
    }

    // Limit decimal places
    if (parts[1]?.length > decimalPlaces) {
        val = parts[0] + '.' + parts[1].slice(0, decimalPlaces)
    }

    return val
}
